

var epicaClick = function (e) {
    if (e.currentTarget.href.indexOf('#') === -1 && e.currentTarget.href.indexOf('void(0)') === -1) {
        var moduleName = e.currentTarget.closest('[data-epica-module-name]').getAttribute('data-epica-module-name');
        dataLayer.push({
            'event': 'epicaClick',
            'epicaClickData': {
                x: e.pageX,
                y: e.pageY,
                moduleName: moduleName,
                href: e.currentTarget.href,
                referer: document.location.href,
                origin: "Asuntos Legales"
            },
            'gaClickData': {
                hitType: 'event',
                eventAction: 'click',
                eventCategory: moduleName,
                eventLabel: document.location.href,
                transport: 'beacon'
            }
        });

    }
};

var epicaAddEventClick = function (selector) {
    var epicaAnchors = document.querySelectorAll(selector + ' a[href]');
    epicaAnchors.forEach(function (el) {
        el.addEventListener('click', epicaClick);
    });
};

epicaAddEventClick('[data-epica-module-name]');

var showEpicaModules = function () {
    var sheet = document.createElement('style');
    sheet.setAttribute("id", "styleSheetEpicaM");
    sheet.innerHTML = "[data-epica-module-name] { border: 3px solid #313131 } [data-epica-module-name]::before { content: attr(data-epica-module-name); display: block; width: 100%; height: 25px; background-color: #313131; color: #ccc; position: relative; font-size: 1.25rem;}";
    document.body.appendChild(sheet);
};

var hideEpicaModules = function () {
    var sheetToBeRemoved = document.getElementById('styleSheetEpicaM');
    var sheetParent = sheetToBeRemoved.parentNode;
    sheetParent.removeChild(sheetToBeRemoved);
};